// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PSGticFYhqkM5m {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.yMTriWBPu3P1Qo {
  display: flex;
  justify-content: center;
}
.H6w9XgZmQVR3PG {
  flex: 1 1 auto;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
  background-color: var(--ds-surface, #ffffff);
}
.hfFmvgj5Nsv_tB {
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
@media only screen and (max-width: 600px) {
  .hfFmvgj5Nsv_tB {
    display: block;
    padding-top: 0;
  }
}
@media only screen and (max-width: 860px) {
  .hfFmvgj5Nsv_tB.bLLcZOIBKv91qe {
    display: block;
    padding-top: 0;
  }
}
.zNF4PilKqFRxK1 {
  width: 960px;
}
@media only screen and (max-width: 1242px) {
  .zNF4PilKqFRxK1 {
    width: 640px;
  }
}
@media only screen and (max-width: 1007px) {
  .zNF4PilKqFRxK1 {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .zNF4PilKqFRxK1.aV3S5xLqdnb2HG {
    display: none;
  }
}
.zNF4PilKqFRxK1.bLLcZOIBKv91qe {
  width: 960px;
}
@media only screen and (max-width: 1520px) {
  .zNF4PilKqFRxK1.bLLcZOIBKv91qe {
    width: 640px;
  }
}
@media only screen and (max-width: 1267px) {
  .zNF4PilKqFRxK1.bLLcZOIBKv91qe {
    width: 100%;
  }
}
.x1L5rEtAlIOeq_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.N1BZRPhJ1ceCJz {
  padding: 0 15%;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
@media only screen and (max-width: 1242px) {
  .N1BZRPhJ1ceCJz {
    padding: 0 10%;
  }
}
.N1BZRPhJ1ceCJz .EP3oUFprPOGD0h {
  width: 100%;
  margin: 16px auto;
}
.iP1tj95wrD21Oe {
  width: 400px;
  padding: 16px 16px 0 16px;
}
.iP1tj95wrD21Oe ul {
  margin-bottom: 16px;
  margin-left: 24px;
  list-style: disc outside none;
}
.IBNG9KcvM2hEBw p {
  display: flex;
  font-weight: var(--ds-font-weight-bold, bold);
}
.IBNG9KcvM2hEBw img {
  align-self: center;
  width: 21px;
  height: 24px;
  margin-right: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `PSGticFYhqkM5m`,
	"flexAndCenter": `yMTriWBPu3P1Qo`,
	"directoryBody": `H6w9XgZmQVR3PG`,
	"navigationAndContent": `hfFmvgj5Nsv_tB`,
	"workspaceNavigationExpanded": `bLLcZOIBKv91qe`,
	"directoryContent": `zNF4PilKqFRxK1`,
	"navigationExpanded": `aV3S5xLqdnb2HG`,
	"directorySpinnerContainer": `x1L5rEtAlIOeq_`,
	"listingWrapper": `N1BZRPhJ1ceCJz`,
	"upgradePromptFullPupPage": `EP3oUFprPOGD0h`,
	"dataConsent": `iP1tj95wrD21Oe`,
	"directoryCompliance": `IBNG9KcvM2hEBw`
};
export default ___CSS_LOADER_EXPORT___;
